

  <!-- Header -->
  <header class="w3-container" style="padding-top:22px">
    <h5 ><b><i class="fa fa-dashboard"></i> Teacher Panel</b></h5>
  </header>
<mat-tab-group>
  <mat-tab label="MC Usage"> 
    <ng-template matTabContent>
  <div class="w3-panel">
    <div class="w3-row-padding" style="margin:0 -16px">
      
    
          <h5>Chart</h5>
          
              
            <mat-card>
          <div id="chartContainer4" style="height: 420px; width: 100%;">{{loadChart3(false)}}
            <mat-progress-bar *ngIf="loading == true" mode="indeterminate"></mat-progress-bar>
            <button *ngIf="loading == false" class="w3-theme-l1" mat-button (click)="loadChart3(true)"><i class="fa fa-refresh"></i> Reload</button>
          
          </div>
        </mat-card>
        
        <hr>
      
   
      
   
        <h5>Student Activities</h5>
        <mat-card>
        <div style="overflow: scroll;">
        <table  class="w3-table w3-striped w3-white">
          <tr>
            <th></th>            
            <th>Student</th>
            <th>Paper Name</th>
            <th>Score</th>
            <th></th>
            <th></th>
            <th>Date</th>
          </tr>
          <tr *ngFor="let activity of activities | async">
            <td><i class="fa fa-pencil"></i></td>
            <td>{{activity.cname}}</td>
            <td>{{activity.type}} - {{activity.tag}}</td>
            <td>{{activity.score}} / {{activity.fullmark}} </td>   
           
            <td><mat-progress-bar class="w3-theme-d1" style="height: 20px;width: 100px" mode="determinate" value="{{activity.percentage *100}}"></mat-progress-bar></td>
            <td>{{activity.percentage | percent}}</td>
            <td>{{activity.date}}</td>
          </tr>
                  
        </table>
      </div>
    </mat-card>

      
    </div>
  </div>
  <hr>
  

  
  <hr>
</ng-template>
  </mat-tab>

 
  <mat-tab label="Student Details"> 
    <ng-template matTabContent>
    <div class="w3-container ">
      <h5>Student Details</h5>
      <div class="alert alert-secondary" role="alert">
          All the registered account will be shown here.
        </div>
        
        <mat-accordion> 
          <mat-expansion-panel disabled>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <table style="width: 100%" class="w3-table w3-striped w3-hoverable w3-white">
                  <tr>
                    <td style="width: 5%"><i class="fa fa-user"></i></td>
                    <td style="width: 15%">Name</td>
                    <td style="width: 10%">Year</td>
                    <td class="w3-hide-small w3-hide-medium" style="width: 15%">Email</td>
                    <td class="w3-hide-small" style="width: 15%">Last Login</td>        
                    <td class="w3-hide-small w3-hide-medium" style="width: 10%">No. of Exercise</td>
                    <td class="w3-hide-small" style="width: 10%">Performance</td>
                    <td class="w3-hide-small" style="width: 10%">Correct Rate</td>
                    <td class="w3-hide-small" style="width: 10%">
                    </td>
                  </tr>
                  </table>
              </mat-panel-title>              
            </mat-expansion-panel-header>
          </mat-expansion-panel>
          <mat-expansion-panel (opened)="getHW(student.email);loadChart4(true,student.GoogleID);loadChart5(true,student.GoogleID);mcdetails(student.GoogleID)" *ngFor="let student of students | async">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <table style="width: 100%" class="w3-table w3-striped w3-hoverable w3-white">
                  <tr>
                    <td style="width: 5%"><i class="fa fa-user"></i></td>
                    <td style="width: 15%">{{student.cname}}</td>
                    <td style="width: 10%">{{student.year}}</td>
                    <td class="w3-hide-small w3-hide-medium" style="width: 15%">{{student.email}}</td>
                    <td class="w3-hide-small" style="width: 15%">{{student.lastlogin}}</td>        
                    <td class="w3-hide-small w3-hide-medium" style="width: 10%">{{student.number}}</td>
                    <td class="w3-hide-small" style="width: 10%">{{student.correct}} / {{student.total}}</td>
                    <td class="w3-hide-small" style="width: 10%">{{student.percentage | percent}}</td>
                    <td class="w3-hide-small" style="width: 10%"><mat-progress-bar class="w3-theme-d1" style="height: 20px;width: 100px" mode="determinate" value="{{student.percentage *100}}"></mat-progress-bar>
                    </td>
                  </tr>
                  </table>
              </mat-panel-title>              
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
            <mat-tab-group>
              <mat-tab label="MC Usage"> 
               
                <div class="w3-twothird">
                  <div id="{{'chartContainer6-'+student.GoogleID}}" style="height: 500px; width: 100%;">
                    <mat-progress-bar *ngIf="loading == true" mode="indeterminate"></mat-progress-bar>
                    <button *ngIf="loading == false" class="w3-theme-l1" mat-button (click)="loadChart4(true,student.GoogleID)"><i class="fa fa-refresh"></i> Reload</button>
                  </div>
                </div>
                <div class="w3-third">
                  <div id="{{'chartContainer7-'+student.GoogleID}}" style="height: 500px; width: 100%;">
                    <mat-progress-bar *ngIf="loading == true" mode="indeterminate"></mat-progress-bar>
                    <button *ngIf="loading == false" class="w3-theme-l1" mat-button (click)="loadChart5(true,student.GoogleID)"><i class="fa fa-refresh"></i> Reload</button>
                  </div>
                </div>
                        
        

              <h5>All Activities</h5>       
                <table  class="w3-table w3-striped w3-white">
                  <tr>
                    <th class="w3-hide-small" ></th>
                    <th>Date</th>
                    <th>Paper Name</th>
                    <th>Score</th>
                    <th>Remaining Time</th>
                    <th class="w3-hide-small" style="width: 20%"></th>                    
                    
                  </tr>
                  <tr *ngFor="let record of mcRecords ">
                    <td class="w3-hide-small" ><i class="fa fa-pencil w3-text-blue w3-large"></i></td>
                    <td><i>{{record.date}}</i></td>
                    <td>{{record.type}} - {{record.tag}}</td>
                    <td>{{record.score}} / {{record.fullmark}} </td>
                    <td>{{record.time}}</td>
                    <td class="w3-hide-small"><mat-progress-bar mode="determinate" value="{{record.percentage * 100}}"></mat-progress-bar>({{record.percentage  | percent}})</td>
                    
                  </tr> 
                </table>
                </mat-tab>
                <mat-tab disabled label="SQ Usage"> 
                </mat-tab>
                <mat-tab disabled label="Comment"> 
                <ng-template matTabContent>
                  
                  <h5>Comments</h5>
                  <table class="w3-table w3-striped">
                    <tr>
                      <th></th>
                      <th>Date</th>
                      <th>Paper Name</th>
                      <th>Question</th>
                      <th>Comment</th>
                    </tr>
                    <tr>
                      <td><i class="fa fa-comment"></i></td>
                      <td>Date</td>
                      <td>Paper Name</td>
                      <td>Question</td>
                      <td>Comment</td>
                    </tr>
                    <tr>
                      <td><i class="fa fa-comment"></i></td>
                      <td>Date</td>
                      <td>Paper Name</td>
                      <td>Question</td>
                      <td>Comment</td>
                    </tr>
                    <tr>
                      <td><i class="fa fa-comment"></i></td>
                      <td>Date</td>
                      <td>Paper Name</td>
                      <td>Question</td>
                      <td>Comment</td>
                    </tr>
                  </table>
                </ng-template>
               </mat-tab>
               <mat-tab [disabled]="homeworks == ''"  label="HW Score"> 
                <ng-template matTabContent>
                 
                  <table class="w3-table w3-striped w3-bordered w3-border w3-hoverable w3-white">
                    <tr>
                      <th style="width: 33%">Name</th>       
                      <th style="width: 33%">Score</th>
                      <th style="width: 33%"></th>
                      
                    </tr>
                    <tr *ngFor="let homework of homeworks | slice:3;let i=index">         
                      <td >{{homework[0]}}</td>      
                      
                      <td colspan="2"  *ngIf="homework[1]?.length >= 10"><a target="_blank" href="{{homework[1]}}"><i class="fa fa-external-link"></i> Open</a></td>
                      <td colspan="2" *ngIf="homework[1] == '-'"><span class="w3-text-red">UNSUBMITTED</span></td>   
                      <td *ngIf="homework[1] != '-' && homework[1]?.length < 10">{{homework[1]}} / {{fullhomeworks[i+3][1]}}</td>
                      <td *ngIf="homework[1] != '-' && homework[1]?.length < 10">
                        <div class="w3-theme-l5">
                          <div [class.w3-theme-l4]="homework[1] / fullhomeworks[i+3][1] < 1"  [class.w3-green]="homework[1] / fullhomeworks[i+3][1]   == 1"  class="w3-container  " [style.width]="homework[1] / fullhomeworks[i+3][1]  | percent">{{homework[1] / fullhomeworks[i+3][1]  | percent}}</div>
                          </div>
                        
                     
                      
                      </td>
                    </tr>
                    
                    
                  </table>
                </ng-template>
               </mat-tab>
               <mat-tab disabled label="MC Question Analysis"> 
                </mat-tab>
            </mat-tab-group>
          </ng-template>
          </mat-expansion-panel>
        </mat-accordion>


      
    </div>
    <br>
  </ng-template>
  </mat-tab>
  <mat-tab  label="Question Analysis"> 
    <ng-template matTabContent>
      <mat-card>
        
        {{loadChart(false)}}
        <div  id="chartContainer2" style="height: 1000px; width: 100%;">
          <mat-progress-bar *ngIf="loading == true" mode="indeterminate"></mat-progress-bar>
        <button *ngIf="loading == false" class="w3-theme-l1" mat-button (click)="loadChart(true)"><i class="fa fa-refresh"></i> Reload</button></div>
        
        <button class="w3-green" mat-button>Export as .csv</button>
      </mat-card>
      
    
  </ng-template>
  </mat-tab>
  <mat-tab  label="Topic Distribution"> 
    <ng-template matTabContent>
      <mat-card>
        
        {{loadChart2(false)}}
        <div  id="chartContainer3" style="height: 1000px; width: 100%;">
          <mat-progress-bar *ngIf="loading == true" mode="indeterminate"></mat-progress-bar>
        <button *ngIf="loading == false" class="w3-theme-l1" mat-button (click)="loadChart2(true)"><i class="fa fa-refresh"></i> Reload</button>
      
      </div>
        
        <button class="w3-green" mat-button>Export as .csv</button>
      </mat-card>
      
    
  </ng-template>
  </mat-tab>
</mat-tab-group>
  

  <!-- Footer -->
  <footer class="w3-container w3-padding-16 w3-theme-d3">
    <h4>Bio.StudyDSE.net</h4>
    <p>Themed by <a href="https://www.w3schools.com/w3css/default.asp" target="_blank">w3.css</a> | <a href="https://material.angular.io/" target="_blank">Angular Material</a> | <a href="https://getbootstrap.com/" target="_blank">Bootstrap</a></p>
    <p>Frontend using <a href="https://angular.io/" target="_blank">Angular</a></p>
  </footer>

  <style type="text/css"> 
    .not-active { 
        pointer-events: none; 
        cursor: default; 
    } 
    </style> 